

















































































































































































































import { getModule } from "vuex-module-decorators";
import { Component, Vue } from "vue-property-decorator";
import ConnectionStore from "@/store/ConnectionStore";

import * as qlog02 from "@/data/QlogSchema02";
import TCPToQLOG from "./pcapconverter/tcptoqlog";
import NetlogToQLOG from "./netlogconverter/netlogtoqlog";
import FileLoader, { FileResult } from "./data/FileLoader";

import StreamingJSONParser from "./utils/StreamingJSONParser";
import QlogConnectionGroup from '../../data/ConnectionGroup';
import { QlogSchemaConverter } from '../../data/QlogSchemaConverter';

@Component({})
export default class FileManagerContainer extends Vue {

    protected store:ConnectionStore = getModule(ConnectionStore, this.$store);

    protected urlToLoad:string = "";
    protected secretsToLoad:string = "";

    protected filesToUpload:Array<File> = new Array<File>();
    protected secretsToUpload:File|null = null;

    public loadURL(){

        if ( this.urlIsPcap && this.secretsToLoad === "" ){
            Vue.notify({
                group: "default",
                title: "Provide .keys file",
                type: "error",
                duration: 6000,
                text: "You're linking to a .pcap without also providing a .keys file. This is currently not supported.",
            });

            return;
        }

        const params:any = {};
        if ( this.urlToLoad.endsWith(".json") ){
            params.list = this.urlToLoad;
        }
        else {
            params.file = this.urlToLoad;
        };

        if ( this.secretsToLoad !== "" ){
            params.secrets = this.secretsToLoad;
        }

        this.store.loadFilesFromServer( params );
    }

    public uploadFile(){

        if ( this.uploadIsPcap && this.secretsToUpload === null ){
            Vue.notify({
                group: "default",
                title: "Provide .keys file",
                type: "error",
                duration: 6000,
                text: "You're uploading a .pcap without also providing a .keys file. This is currently not supported.",
            });

            return;
        }

        for ( const file of this.filesToUpload ){

            if ( file === null || (!file.name.endsWith(".qlog") && !file.name.endsWith(".sqlog") && !file.name.endsWith(".json")) && !file.name.endsWith(".netlog") && !file.name.endsWith(".qlognd")) {
                Vue.notify({
                    group: "default",
                    title: "Provide .qlog/.sqlog file",
                    type: "error",
                    duration: 6000,
                    text: "We currently only support uploading .qlog/.sqlog files. " + file.name,
                });
            
                return;
            }
        }

        for ( const file of this.filesToUpload ){

            const uploadFileName = file.name;
            Vue.notify({
                group: "default",
                title: "Loading uploaded file",
                text: "Loading uploaded file " + uploadFileName + ".<br/>The file is not sent to a server.",
            });

            // const reader = new FileReader();

            // reader.onload = (evt) => {
            //     try{

            //         if ( file.name.endsWith(".qlog") ) {
            //             const contentsJSON = StreamingJSONParser.parseQlogText( (evt!.target as any).result );
            //             this.store.addGroupFromQlogFile({fileContentsJSON: contentsJSON, fileInfo:{ filename: uploadFileName }});
            //         }
            //         else if ( file.name.endsWith(".json") ) {
            //             const contentsJSON = StreamingJSONParser.parseJSONWithDeduplication( (evt!.target as any).result );

            //             const qlogJSON = TCPToQLOG.convert( contentsJSON );
            //             this.store.addGroupFromQlogFile({fileContentsJSON: qlogJSON, fileInfo:{ filename: uploadFileName }});
            //         } 
            //         else if (file.name.endsWith(".netlog")) {
            //             const contentsJSON = JSON.parse( (evt!.target as any).result );
                        
            //             const qlogJSON = NetlogToQLOG.convert( contentsJSON );
            //             this.store.addGroupFromQlogFile({fileContentsJSON: qlogJSON, fileInfo:{ filename: uploadFileName }});
            //         }
            //         else if (file.name.endsWith(".qlognd")) {
            //             // const contentsJSON = JSON.parse( (evt!.target as any).result );
                        
            //             // const qlogJSON = NetlogToQLOG.convert( contentsJSON );
            //             // this.store.addGroupFromQlogFile({fileContentsJSON: qlogJSON, fileInfo:{ filename: uploadFileName }});
            //             let countedEvents = 0;
            //             let events:any = [];
                        

            //             // const fileContents = new Response( (evt!.target as any).result );

            //             // ndjsonStream( fileContents ).then ( (jsonStream:any) => {

            //             // console.log( file );
            //             // console.log( Object.keys(file) );

            //             // ref: https://stackoverflow.com/questions/14438187/javascript-filereader-parsing-long-file-in-chunks
            //             // let blob = new Blob([(evt!.target as any).result]);
            //             // let resp = new Response(blob).body;
            //             let resp = new Response(file).body;


            //             let countTheStuff:any = () => {
            //                 countedEvents++;
            //             };

            //             let jsonStream = ndjsonStream( resp );
            //             console.log("NDSTREAM ", jsonStream);

            //             // ndstream.then ( (jsonStream:any) => {
            //                 const streamReader = jsonStream.getReader(); 
            //                 let read:any = undefined;

            //                 streamReader.read().then( read = ( result:any ) => {
            //                     if ( result.done ) {
            //                         let endTime = performance.now();
            //                         console.log("NDJSON ALL DONE!", endTime - startTime, countedEvents, events.length);
            //                         return;
            //                     }

            //                     countTheStuff();
            //                     console.log( result.value.length, result.value );

            //                     streamReader.read().then( read );
            //                 } );
            //             // });

            //             // const input = Readable.from( [(evt!.target as any).result] );

            //             // robin: need to switch to something that uses JS streams isntead of NodeJS streams because this ecosystem sucks
            //             // this seems to have potential: https://canjs.com/doc/can-ndjson-stream.html

            //             // let self = this;

            //             // input.on("end", function() {
            //             //     self.store.addGroupFromQlogFile({fileContentsJSON: {}, fileInfo:{ filename: uploadFileName }});

            //             //     console.log("Total events read: ", countedEvents, events.length );
            //             // });
                        
            //             // input.on("error", function(e:any) { 
            //             //     console.error("qlogFullToQlogND:validate : error during reading filecontents!", e);
            //             //     // resolver();
            //             // });
                        
            //             // input.pipe(ndjson.parse())
            //             // .on('data', function(obj:any) {
            //             //     ++countedEvents;
            //             //     // console.log( "COUNTED", countedEvents, obj );

            //             //     events.push( obj );
            //             // })

            //         }
            //         else { 
            //             throw new Error("unsupported file format : " + uploadFileName);
            //         }

            //         Vue.notify({
            //             group: "default",
            //             title: "Uploaded file",
            //             type: "success",
            //             text: "The uploaded file is now available for visualization " + uploadFileName + ".<br/>Use the menu above to switch views.",
            //         });
            //     }
            //     catch (e){
                    
            //         console.error("FileManagerContainer:uploadFile : ", e);
            //         Vue.notify({
            //             group: "default",
            //             title: "Error uploading file",
            //             type: "error",
            //             duration: 6000,
            //             text: "Something went wrong. " + uploadFileName + ". For more information, view the devtools console.",
            //         });
            //     }
            // };

            // let identifier = new FileReader();

            // let firstFewBytes = file.slice(0, 1024); // first 1000 bytes should contain qlog_version

            // identifier.onload = (evt) => { 
            //     let firstFewCharacters = (evt!.target as any).result;

            //     console.log("FIRST FEW CHARACTERS ARE: ", firstFewCharacters, firstFewCharacters.indexOf("qlog_version") >= 0 ); 

            //     reader.readAsText(file);
            // };

            // identifier.readAsText(firstFewBytes);

            FileLoader.Load( file, file.name ).then( (result:FileResult) => {
                
                this.store.addGroupFromQlogFile({fileContentsJSON: result.qlogJSON, fileInfo:{ filename: uploadFileName }});

                Vue.notify({
                    group: "default",
                    title: "Uploaded file",
                    type: "success",
                    text: "The uploaded file is now available for visualization " + uploadFileName + ".<br/>Use the menu above to switch views.",
                });
            })
            .catch( (reason:any) => {
                console.error("FileManagerContainer:uploadFile : ", reason);

                Vue.notify({
                    group: "default",
                    title: "Error uploading file",
                    type: "error",
                    duration: 6000,
                    text: "Something went wrong. " + uploadFileName + ". For more information, view the devtools console.",
                });
            });
        }


        // // https://serversideup.net/uploading-files-vuejs-axios/
        // const formData = new FormData();
        // formData.append("file", this.fileToUpload!);
        // formData.append("secrets", this.secretsToUpload!);

        // console.log( formData);
        
        // axios.post( '/loadfiles',
        //     formData,
        //     {
        //         headers: {
        //             'Content-Type': 'multipart/form-data'
        //         }
        //     }
        // ).then(function(){
        // console.log('SUCCESS!!');
        // })
        // .catch(function(){
        // console.log('FAILURE!!');
        // });

    }

    public loadExamples(){
        let alreadyLoaded = false;
        for (const  group of this.store.groups ){
            if ( group.filename.indexOf("DEMO") === 0 ){
                alreadyLoaded = true;
                break;
            }
        }

        if ( alreadyLoaded ){

            Vue.notify({
                group: "default",
                title: "Example files already loaded",
                type: "warn",
                text: "Example files were already loaded, check for files with the 'DEMO_' prefix.",
            });

            return;
        }

        this.store.loadExamplesForDemo();
    }

    public loadMassiveExample(){
        let alreadyLoaded = false;
        for (const  group of this.store.groups ){
            if ( group.filename.indexOf("MASSIVE_DEMO_mvfst_large") >= 0 ){
                alreadyLoaded = true;
                break;
            }
        }

        if ( alreadyLoaded ){

            Vue.notify({
                group: "default",
                title: "Example file already loaded",
                type: "warn",
                text: "Example file was already loaded, it is called 'MASSIVE_DEMO_mvfst_large'.",
            });

            return;
        }

        this.store.loadQlogDirectlyFromURL( { url : "standalone_data/draft-00/mvfst_large.qlog", filename: "MASSIVE_DEMO_mvfst_large.qlog (31MB)"} );
    }

    public removeGroup(group:QlogConnectionGroup) {
        console.log("FileManagerContainer:removeGroup : removing group ", group);

        this.store.removeGroup( group );
    }

    public downloadGroup(group:QlogConnectionGroup) {
        console.log("FileManagerContainer:downloadGroup : downloading internal qlog representation of group ", group);

        const internalQlog = QlogSchemaConverter.Convert01to02( group );

        const DEBUGfilter = false;
        if ( DEBUGfilter ) {
            for ( const connection of internalQlog.traces ) {
                const newEvents = (connection as qlog02.ITrace).events.filter( (evt) => (
                    evt.name === qlog02.EventCategory.transport + ":" + qlog02.TransportEventType.packet_sent ||
                    evt.name === qlog02.EventCategory.transport + ":" + qlog02.TransportEventType.packet_received ||
                    evt.name === qlog02.EventCategory.transport + ":" + qlog02.TransportEventType.parameters_set ||
                    evt.name === qlog02.EventCategory.http + ":" + qlog02.HTTP3EventType.frame_created ||
                    evt.name === qlog02.EventCategory.http + qlog02.HTTP3EventType.frame_parsed ||
                    evt.name!.indexOf("session_ticket_used") >= 0
                ));

                (connection as qlog02.ITrace).events = newEvents;
            }
        }

        let filename = "" + group.filename;
        if ( group.URL && group.URL.length > 0 ) {
            filename = group.URL.substr( group.URL.lastIndexOf("/") );
        }

        if ( filename.length === 0 ) {
            filename = "trace";
        }

        if ( !filename.endsWith(".qlog") ) {
            filename += ".qlog";
        }

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL( new Blob([JSON.stringify(internalQlog, null, 2)], {type : 'application/json'}) );
        link.download = filename;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    protected get urlIsPcap(){
        return this.urlToLoad.indexOf(".pcap") >= 0 && this.urlToLoad.indexOf(".pcapng") < 0;
    }

    protected get uploadIsPcap(){
        return false; // this.fileToUpload !== null && this.fileToUpload.name.indexOf(".pcap") >= 0;
    }

    protected get filesLoaded() {
        return this.store.groups.length > 0;
    }

    protected get allGroups() {
        return this.store.groups;
    }
}
